import React from "react";
import { useTranslations } from "next-intl";
import type { IRamadanRiddleUserReward } from "@types";
import ExpirationStatusText from "@elements/expiration-status-text";

interface RamadanRewardCardProps {
    reward: IRamadanRiddleUserReward;
    onViewReward: (reward: IRamadanRiddleUserReward) => void;
}

const RamadanRewardCard: React.FC<RamadanRewardCardProps> = ({ reward, onViewReward }) => {
    const t = useTranslations();
    const unavailabilityReason = reward.unavailability_reason?.trim();

    return (
        <div className="rounded-2xl border border-[#EAEAEA] bg-[#FEEFD2] px-4 py-4">
            <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                    <p className="text-xs font-bold uppercase tracking-wide text-[#956C4A]">
                        {reward.day_name_title}
                    </p>
                    <p className="mt-1 text-base font-extrabold uppercase text-[#38190D]">
                        {reward.subTitle}
                    </p>
                    {unavailabilityReason ? (
                        <p className="mt-2 text-xs font-semibold text-[#956C4A]">
                            {unavailabilityReason}
                        </p>
                    ) : reward.validUntil ? (
                        <ExpirationStatusText
                            className="mt-2 text-xs font-semibold"
                            validUntil={reward.validUntil}
                        />
                    ) : null}
                </div>
                {!unavailabilityReason ? (
                    <button
                        type="button"
                        onClick={() => onViewReward(reward)}
                        className="whitespace-nowrap text-sm font-semibold text-[#008AF6] my-auto"
                    >
                        {t("View reward")}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default RamadanRewardCard;
